import * as React from "react";
import { memo, useCallback, useEffect, useRef } from "react";
import "./movieBlockViewStyles.css";
import { ContinueWatchingItemView } from "../movie/ContinueWatchingItemView";
import { focusManager } from "../../../utils/Focus";
export var ContinueWatchingBlockView = memo(function (_a) {
    var title = _a.title, continueWatchingBlock = _a.continueWatchingBlock, onMoviePress = _a.onMoviePress;
    var containerRef = useRef(null);
    useEffect(function () {
        if (containerRef.current) {
            focusManager.registerGroup({
                name: "continueWatchingBlock",
                horizontalContainer: containerRef.current,
            });
        }
    }, []);
    var renderItem = useCallback(function (c, i) {
        return (React.createElement(ContinueWatchingItemView, { focusRaw: ["continueWatchingBlock", i], key: c.movie.id, movie: c.movie, watchHistory: c.watchHistory, onMoviePress: onMoviePress }));
    }, []);
    return (React.createElement("div", { className: "block-container" },
        React.createElement("h2", null, title),
        React.createElement("div", { ref: containerRef, className: "block-movies-container" }, continueWatchingBlock.length > 0
            ? continueWatchingBlock.map(function (block, index) {
                return renderItem(block, index);
            })
            : null)));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/block/ContinueWatchingBlockView.tsx
// module id = 144
// module chunks = 1